/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Cell, Grid, Text } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { useFatoresRiscoQuery } from 'graphql/hooks.generated'
import { Fragment, useMemo, useState } from 'react'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { AvaliacaoDesenvolvimentoModel } from '../model'
import { avaliacaoPresenteList } from '../util/avaliacaoPresenteList'
import { FatoresRiscoModal } from './FatoresRiscoModal'

export interface FatoresRiscoModel {
  fatoresRisco: AvaliacaoDesenvolvimentoModel[]
}

interface FatoresRiscoViewProps {
  name: MetaPath<FatoresRiscoModel>
  prontuarioId: ID
}

export function FatoresRiscoView(props: FatoresRiscoViewProps) {
  const { name, prontuarioId } = props
  const [openModal, setOpenModal] = useState(false)

  const {
    input: { value, onChange },
  } = useField<FatoresRiscoModel>(name.absolutePath())

  useFatoresRiscoQuery({
    variables: {
      prontuarioId: prontuarioId,
    },
    onCompleted: (data) =>
      !value &&
      onChange({
        fatoresRisco: data?.fatoresRisco
          .map((item) => ({ ...item, statusButton: item.status }))
          .sort((a, b) => Number(a.id) - Number(b.id)),
      }),
    skip: !!value,
  })

  const descricaoDeFatoresPresentes = useMemo(() => avaliacaoPresenteList(value.fatoresRisco), [value.fatoresRisco])

  return (
    <Fragment>
      <Grid alignItems='center'>
        <Cell size={3}>
          <Button
            style={css`
              width: 100%;
            `}
            size='small'
            kind='primary'
            onClick={() => setOpenModal(true)}
          >
            Avaliar fatores de risco
          </Button>
        </Cell>
        <Cell size={9}>
          <HLabel title='Fatores de risco:'>
            {descricaoDeFatoresPresentes || <Text fontStyle='italic'>Nenhum fator de risco presente</Text>}
          </HLabel>
        </Cell>
      </Grid>
      {openModal && (
        <FatoresRiscoModal initialValues={value} closeModal={() => setOpenModal(false)} updateFatoresRisco={onChange} />
      )}
    </Fragment>
  )
}
